import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Alert,
  Collapse,
  Button,
  Label,
} from "reactstrap";
import { DataTable, ExportCSV } from "../../../../components";
import {
  getPaymentDetailsBalance,
  getPaymentTypesBalance,
} from "../../../../store/report/actions";
import { layout, roles, messages } from "../../../../common/constants";
import MediaQuery from "react-responsive";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import * as columns from "./_columns";
import { formatHelper } from "../../../../common/helpers";
import {
  getPaymentTypesBalance as paymentMethodsBalanceExport,
  getPaymentDetailsBalance as paymentMethodsBalanceDetailedExport,
  getDetailedSellsPaymentBalance as detailedSellsPaymentBalanceExport,
} from "../../../../service/report";
import { getStores } from "../../../../store/store/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { selectStoresForSelect } from "../../../../store/store/selector";
import Select from "react-select";
import { exportExcelGeneral, exportExcel } from "./excel";

class PaymentBalance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
      pageDetails: 1,
      pageTypes: 1,
      loadingExport: false,
      selectedStore: null,
    };
    this.handleObtainReportExport = this.handleObtainReportExport.bind(this);

    this.handleObtainDetailedReportExport =
      this.handleObtainDetailedReportExport.bind(this);

    this.handlePageDetailsChange = this.handlePageDetailsChange.bind(this);
    this.handlePageTypesChange = this.handlePageTypesChange.bind(this);

    this.handleStoreChange = this.handleStoreChange.bind(this);
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });

    if (
      this.state.startDate &&
      this.state.endDate &&
      this.state.selectedStore
    ) {
      this.props.getPaymentDetailsBalance({
        page: this.state.pageDetails,
        startDate: this.state.startDate._d,
        endDate: this.state.endDate._d,
        store: this.state.selectedStore.value,
      });
      this.props.getPaymentTypesBalance({
        page: this.state.pageNames,
        startDate: this.state.startDate._d,
        endDate: this.state.endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetPaymentBalance();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  handlePaymentBalanceDateChange(startDate, endDate) {
    this.setState({ startDate, endDate });

    if (startDate != null && endDate != null) {
      this.props.getPaymentDetailsBalance({
        page: this.state.pageDetails,
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
      this.props.getPaymentTypesBalance({
        page: this.state.pageTypes,
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  performGetPaymentBalance(reset = false, getPaymentBalance, page) {
    getPaymentBalance({
      page,
      startDate: this.state.startDate._d,
      endDate: this.state.endDate._d,
      store: this.state.selectedStore.value,
      reset,
    });
  }

  async handlePageDetailsChange(pageDetails) {
    await this.setState({ pageDetails: pageDetails });
    this.performGetPaymentBalance(
      false,
      this.props.getPaymentDetailsBalance,
      this.state.pageDetails
    );
  }
  async handlePageTypesChange(pageTypes) {
    await this.setState({ pageTypes: pageTypes });
    this.performGetPaymentBalance(
      false,
      this.props.getPaymentTypesBalance,
      this.state.pageTypes
    );
  }

  renderDataTable(
    columns,
    data,
    page,
    total,
    pageSize,
    loading,
    handlePageChange
  ) {
    return (
      <DataTable
        data={data}
        keyField="id"
        columns={columns}
        page={page}
        totalSize={total}
        sizePerPage={pageSize}
        loading={loading}
        onPageChange={handlePageChange}
      />
    );
  }

  handleObtainDetailedReportExport() {
    this.setState({ loadingExport: true });
    const { startDate, endDate, selectedStore } = this.state;
    detailedSellsPaymentBalanceExport(
      startDate._d,
      endDate._d,
      selectedStore.value
    )
      .then((response) => {
        exportExcel(response.data.data, selectedStore, startDate, endDate);
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  handleObtainReportExport() {
    this.setState({ loadingExport: true });
    const { startDate, endDate, selectedStore } = this.state;
    paymentMethodsBalanceExport(
      0,
      startDate._d,
      endDate._d,
      selectedStore.value
    )
      .then((response) => {
        exportExcelGeneral(
          response.data.data,
          selectedStore,
          startDate,
          endDate
        );
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  render() {
    const { startDate, endDate, pageDetails, pageTypes, loadingExport } =
      this.state;
    const {
      paymentDetailsBalance,
      totalDetails,
      pageSizeDetails,
      loadingDetails,
      paymentTypesBalance,
      totalTypes,
      pageSizeTypes,
      loadingTypes,
    } = this.props;
    return (
      <div>
        <Card>
          <CardHeader>
            <i className="icon-chart" />
            Balance por Formas de Pago
          </CardHeader>
          <CardBody>
            {(this.props.role == roles.SUPER_ADMIN ||
              this.props.role == roles.ADMIN) && (
              <Row className="my-4">
                <Col sm="1">
                  <Label className="mt-2">Tienda:</Label>
                </Col>

                <Col sm="4">
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isLoading={this.props.loadingStores}
                    isSearchable={true}
                    noOptionsMessage={() => {
                      return messages.SELECT_NO_OPTIONS;
                    }}
                    placeholder=""
                    options={this.props.stores}
                    loadingMessage={() => {
                      return messages.SELECT_LOADING;
                    }}
                    onChange={this.handleStoreChange}
                    value={this.state.selectedStore}
                    isDisabled={
                      this.props.loadingStores || loadingDetails || loadingTypes
                    }
                  />
                </Col>
              </Row>
            )}
            <Row className="mb-2">
              <Col md="5">
                <DateRangePicker
                  startDate={startDate}
                  startDateId="startDate"
                  endDate={endDate}
                  endDateId="endDate"
                  displayFormat={"DD/MM/YYYY"}
                  disabled={
                    this.props.loadingStores || loadingDetails || loadingTypes
                  }
                  onDatesChange={({ startDate, endDate }) =>
                    this.handlePaymentBalanceDateChange(startDate, endDate)
                  }
                  focusedInput={this.state.focusedInput}
                  onFocusChange={(focusedInput) =>
                    this.setState({ focusedInput })
                  }
                  startDatePlaceholderText="Fecha Inicio"
                  endDatePlaceholderText="Fecha Fin"
                  small
                  isOutsideRange={() => false}
                  hideKeyboardShortcutsPanel
                  minimumNights={0}
                />
              </Col>
              <Col md="7">
                {this.state.startDate && this.state.endDate ? (
                  <Row>
                    <Col md="12">
                      <ExportCSV
                        disabled={loadingExport}
                        exportCSV={this.handleObtainReportExport}
                        minWidth={800}
                      />
                      <ExportCSV
                        disabled={loadingExport}
                        exportCSV={this.handleObtainDetailedReportExport}
                        minWidth={800}
                        detailed={true}
                      />
                    </Col>
                  </Row>
                ) : null}
              </Col>
            </Row>

            <hr className="my-4" />
            {startDate != null && endDate != null ? (
              <Row>
                <Col>
                  <Row className="mb-2">
                    <Col>
                      <b>Total de Ventas (S/):</b>{" "}
                      {formatHelper.toMoney(this.props.totalBought)}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsPaymentDetailsXS,
                          paymentDetailsBalance,
                          pageDetails,
                          totalDetails,
                          pageSizeDetails,
                          loadingDetails,
                          this.handlePageDetailsChange
                        )}
                      </MediaQuery>
                      <MediaQuery
                        minWidth={layout.SM_MIN_WIDTH}
                        maxWidth={layout.MD_MAX_WIDTH}
                      >
                        {this.renderDataTable(
                          columns.columnsPaymentDetailsSM,
                          paymentDetailsBalance,
                          pageDetails,
                          totalDetails,
                          pageSizeDetails,
                          loadingDetails,
                          this.handlePageDetailsChange
                        )}
                      </MediaQuery>
                      <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsPaymentDetailsMD,
                          paymentDetailsBalance,
                          pageDetails,
                          totalDetails,
                          pageSizeDetails,
                          loadingDetails,
                          this.handlePageDetailsChange
                        )}
                      </MediaQuery>
                    </Col>
                  </Row>
                  <hr className="my-4" />
                  <Row>
                    <Col>
                      <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsPaymentSellsXS,
                          paymentTypesBalance,
                          pageTypes,
                          totalTypes,
                          pageSizeTypes,
                          loadingTypes,
                          this.handlePageTypesChange
                        )}
                      </MediaQuery>
                      <MediaQuery
                        minWidth={layout.SM_MIN_WIDTH}
                        maxWidth={layout.MD_MAX_WIDTH}
                      >
                        {this.renderDataTable(
                          columns.columnsPaymentSellsSM,
                          paymentTypesBalance,
                          pageTypes,
                          totalTypes,
                          pageSizeTypes,
                          loadingTypes,
                          this.handlePageTypesChange
                        )}
                      </MediaQuery>
                      <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsPaymentSellsMD,
                          paymentTypesBalance,
                          pageTypes,
                          totalTypes,
                          pageSizeTypes,
                          loadingTypes,
                          this.handlePageTypesChange
                        )}
                      </MediaQuery>
                    </Col>
                  </Row>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col>
                  <Alert color="info">
                    Seleccione un rango de fechas para visualizar los datos
                  </Alert>
                </Col>
              </Row>
            )}
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const paymentDetailsBalanceList = state.report.paymentDetailsBalanceList;
  const paymentTypesBalanceList = state.report.paymentTypesBalanceList;
  return {
    paymentDetailsBalance: paymentDetailsBalanceList.paymentDetailsBalance,
    totalBought: paymentDetailsBalanceList.totalBought,
    totalDetails: paymentDetailsBalanceList.total,
    pageSizeDetails: paymentDetailsBalanceList.pageSize,
    errorDetails: paymentDetailsBalanceList.error,
    loadingDetails: paymentDetailsBalanceList.loading,

    paymentTypesBalance: paymentTypesBalanceList.paymentTypesBalance,
    totalTypes: paymentTypesBalanceList.total,
    pageSizeTypes: paymentTypesBalanceList.pageSize,
    errorTypes: paymentTypesBalanceList.error,
    loadingTypes: paymentTypesBalanceList.loading,

    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getPaymentDetailsBalance,
      getPaymentTypesBalance,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentBalance);



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/PaymentBalance/PaymentBalance.js